module.exports = __webpack_public_path__ + "static/media/acceptCallIcon.ca6e0857.svg";